var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeliport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 10.5273 9.96582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 9.96582,
    opacity: 0,
    width: 10.5273,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.98047 9.96094C7.72949 9.96094 9.96094 7.72949 9.96094 4.98047C9.96094 2.23145 7.72949 0 4.98047 0C2.23145 0 0 2.23145 0 4.98047C0 7.72949 2.23145 9.96094 4.98047 9.96094ZM4.98047 9.13086C2.68555 9.13086 0.830078 7.27539 0.830078 4.98047C0.830078 2.68555 2.68555 0.830078 4.98047 0.830078C7.27539 0.830078 9.13086 2.68555 9.13086 4.98047C9.13086 7.27539 7.27539 9.13086 4.98047 9.13086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.43262 7.2168C3.68652 7.2168 3.82812 7.05566 3.82812 6.78223L3.82812 5.1709L6.11328 5.1709L6.11328 6.78223C6.11328 7.05078 6.25977 7.2168 6.49902 7.2168C6.75293 7.2168 6.89453 7.05566 6.89453 6.78223L6.89453 3.08594C6.89453 2.8125 6.75293 2.65137 6.49902 2.65137C6.25977 2.65137 6.11328 2.81738 6.11328 3.08594L6.11328 4.56055L3.82812 4.56055L3.82812 3.08594C3.82812 2.8125 3.68652 2.65137 3.43262 2.65137C3.19336 2.65137 3.05176 2.81738 3.05176 3.08594L3.05176 6.78223C3.05176 7.05078 3.19336 7.2168 3.43262 7.2168Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeliport);
export default __webpack_public_path__ + "static/media/heliport.eff368b0086c8431c903bb1aed82a8c0.svg";
export { ForwardRef as ReactComponent };